import Vue from 'vue'
import Vuex from 'vuex'
import appSize from './modules/appSize'
import documentation from './modules/documentation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    appSize,
    documentation
  }
})
